const moment = require('moment');
const GeneratedSkillDrills = require('./skillDrills');
const DriverOperatorSkillDrills = require('./skillDrillsDriverOperator');
const Nfpa1010SkillDrills = require('./skillDrillsNfpa1010');
const {COTR_LEVEL_MAP, CotrSkillDrills} = require('./skillDrillsCotr');

// ./skillDrills.js is auto-generated from the VIERA/IFSTA recruit drill list; the OFC
// driver/operator check sheet isn't part of that list, so it's maintained by hand in
// ./skillDrillsDriverOperator.js and merged here. Keeping it out of the generated file
// means regenerating can't silently drop it (#1579). The NFPA 1010 (J&B) ladder is a
// separate program again and lives in ./skillDrillsNfpa1010.js.
const SkillDrills = {
    ...GeneratedSkillDrills,
    [DriverOperatorSkillDrills.key]: DriverOperatorSkillDrills,
    ...Nfpa1010SkillDrills,
    ...CotrSkillDrills
};
const {
    toDateValue,
    normalizeStatusChanges,
    resolveEffectiveStatus,
    isActiveOn,
    intervalsContain,
    activeIntervals
} = require('./memberStatus');
const {
    PRECISIONS: RankPrecisions,
    precisionOf,
    coarserPrecision,
    normalizeToPrecision,
    sameInstantAtPrecision,
    normalizeRankChanges,
    resolveEffectiveRank,
    rankTimeline: rankTimelineRows,
    TEMPORARY_APPOINTMENTS,
    appointmentTypeOf,
    isTemporaryAppointment,
    permanentRanks
} = require('./memberRank');
const {
    cleanStationValue,
    stationAddressText,
    stationName,
    stationNumber,
    stationDisplayName
} = require('./stations');
const {
    trainingAttendeeUids,
    attendedTraining,
    normalizeTrainingType,
    groupTrainingsByType
} = require('./trainingAttendance');
const {DEFAULT_STANDBY_HOURS, resolveIncidentMemberRole, resolveIncidentHours} = require('./data/incidentHours');
const {calculateDutyShiftHours, resolveDutyShiftHours} = require('./data/dutyShiftHours');
const {
    EVALUATION_FORM_THRESHOLD,
    drillsNeededForEvaluationForm,
    meetsEvaluationFormThreshold
} = require('./data/evaluationFormThreshold');
const {DEPARTMENT_TIMEZONE, getIncidentMonth, getIncidentMonthRange} = require('./data/incidentMonths');
const {
    RESPONSE_LISTS,
    DEFAULT_IAR_IGNORED_RESPONSES,
    classifyIarResponse,
    latestIarResponses,
    iarResponseSnapshot,
    groupResponsesByList,
    mergeImportedResponses
} = require('./data/responseLists');
const {timeOffIntervalsByMember, timeOffCovering} = require('./data/timeOff');
const {
    PERFORMANCE_CHECKLIST_STEP,
    PERFORMANCE_CHECKLIST_HEADING,
    PERFORMANCE_CHECKLIST_ITEM_TYPES,
    PERFORMANCE_CHECKLIST_MAX_ITEMS,
    normalizePerformanceChecklist,
    checklistSteps,
    hasPerformanceChecklist,
    PERFORMANCE_CHECKLIST_PASS,
    PERFORMANCE_CHECKLIST_FAIL,
    ASSESSMENT_NOT_STARTED,
    ASSESSMENT_IN_PROGRESS,
    ASSESSMENT_PASS,
    ASSESSMENT_FAIL,
    assessmentProgress,
    deriveAssessmentStatus
} = require('./data/performanceChecklist');
const {
    OTHER_APPARATUS_ID,
    isOtherApparatus,
    normalizeTag,
    findApparatusByTag,
    apparatusEntryLabel,
    rotationCrewIds,
    deploymentIntervalsByMember,
    deploymentCovering,
    clusterConcurrentSessions,
    clusterAttendedBy,
    memberStationId,
    memberIncidentAttendance,
    memberTrainingAttendance
} = require('./data/memberAttendance');
const {
    LEVEL_LADDERS,
    LEVEL_CERT_PATHS,
    levelLadder,
    isLevelCellComplete,
    impliedByLevel,
    isLevelComplete,
    levelsAtOrBelow,
    levelsCoveredByCredit,
    creditableLevels,
    isImpliableSkill,
    impliableCells,
    isImpliableCell,
    isLevelCert,
    levelCerts,
    levelCompletionCells,
    areAllLevelRequirementsComplete,
    outstandingLevelCerts,
    SKILL_IMPLICATIONS,
    skillImplications,
    isImpliedSkillCreditable,
    impliedSkillCells,
    cellHasOwnRecord
} = require('./qualificationLevels');
const {
    OPERATOR_UID,
    HUB_ACCOUNT_UID_PREFIX,
    isOperatorUid,
    isHubAccountUid,
    hubAccountUid,
    parseHubAccountUid,
    isHiddenAccount
} = require('./accounts');
const {
    SHARED_QUALIFICATION_PATHS,
    LEGACY_QUALIFICATION_PATHS,
    PROVIDER_LEGACY_QUALIFICATION_PATHS,
    preferredLegacyQualificationPath,
    canonicalQualificationPath,
    canonicalQualificationGrouping,
    withCanonicalQualificationFiles,
    qualificationCellAt,
    qualificationDisplayCellAt,
    qualificationCellSourcePath,
    withSharedQualificationFallbacks
} = require('./sharedQualificationPaths');
const {
    DEFAULT_TRAINING_PROVIDER,
    resolveSkillDef: resolveSkillDefIn,
    unionCatalogues,
    createSkillCatalog
} = require('./skillCatalog');
const {
    VieraSkillSheets,
    SOURCE_BASE: VieraSkillSheetSourceBase,
    CURRENT_EDITION: VieraSkillSheetEdition,
    CURRENT_EDITION_LABEL: VieraSkillSheetEditionLabel,
    EDITION_RE: VieraSkillSheetEditionRe,
    skillSheetPath,
    skillSheetSkillPath,
    hasSkillSheet,
    getSkillSheet,
    getSkillSheetGeometry,
    skillSheetsForChapter,
    sourceUrl: vieraSkillSheetSourceUrl
} = require('./vieraSkillSheets');
const {
    OFCDriverOperatorSheets,
    CURRENT_EDITION: OFCDriverOperatorEdition,
    CURRENT_EDITION_LABEL: OFCDriverOperatorEditionLabel,
    getOFCDriverOperatorSheet,
    ofcDriverOperatorSheetPath,
    ofcSheetForDrill,
    ofcDocsForExam
} = require('./ofcDriverOperatorSheets');
const {
    OnboardingRequestStatuses,
    OPEN_ONBOARDING_REQUEST_STATUSES,
    OPERATOR_ONBOARDING_REQUEST_STATUSES,
    WITHDRAWABLE_ONBOARDING_REQUEST_STATUSES,
    OnboardingRequestKinds,
    LinkProviders,
    normalizeLink,
    detectLinkProvider
} = require('./onboardingRequests');

const Permissions = {
    regionalCalendar: {
        label: 'Regional Calendar',
        permissions: {read: false, request: false, manage: false}
    },
    stations: {
        label: 'Stations',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    users: {
        label: 'Users',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    apparatus: {
        label: 'Apparatus',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    fuel: {
        label: 'Fuel',
        permissions: {
            read: true,
            write: true,
            delete: false
        }
    },
    apparatusChecks: {
        label: 'Apparatus Checks',
        permissions: {
            read: true,
            write: true,
            delete: false,
            approve: false
        }
    },
    gearChecks: {
        label: 'Gear Checks',
        permissions: {
            read: true,
            write: true,
            delete: false,
            approve: false
        }
    },
    stationChecks: {
        label: 'Station Checks',
        permissions: {
            read: true,
            write: true,
            delete: false,
            approve: false
        }
    },
    editChecks: {
        label: 'Edit Checks',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    incidents: {
        label: 'Incidents',
        permissions: {
            stats: true,
            read: false,
            write: false,
            delete: false,
            approve: false
        }
    },
    reports: {
        label: 'Reports',
        permissions: {
            read: false,
            write: false
        }
    },
    events: {
        label: 'Events',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    training: {
        label: 'Training',
        permissions: {
            stats: true,
            read: false,
            write: false,
            delete: false,
            approve: false
        }
    },
    lessonplans: {
        label: 'Lesson Plans',
        permissions: {
            read: false,
            write: false,
            delete: false
        }
    },
    requirements: {
        label: 'Requirements',
        permissions: {
            read: false,
            write: false,
            delete: false,
            assign: false,
            report: false,
            approve: false
        }
    },
    gear: {
        label: 'Gear',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    items: {
        label: 'Items',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    records: {
        label: 'Records',
        permissions: {
            read: true,
            write: true,
            delete: false
        }
    },
    tasks: {
        label: 'Tasks',
        permissions: {
            read: false,
            write: true,
            delete: false
        }
    },
    payroll: {
        label: 'Payroll',
        permissions: {
            read: false,
            write: false,
            approve: false,
            submitHours: false
        }
    },
    nfpa: {
        label: 'NFPA Standards',
        permissions: {
            read: true
        }
    },
    dutyShifts: {
        label: 'Duty Shifts',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    preplans: {
        label: 'Preplans',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    // The burning-permit list a regional district sends the department (names,
    // addresses and contact details of residents holding a permit). Readable by
    // default so a crew can check an address on a smoke call; replacing or
    // clearing the list is an officer job.
    burnPermits: {
        label: 'Burn Permits',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    sops: {
        label: 'SOPs/SOGs',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    files: {
        label: 'Files',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    },
    publicEducation: {
        label: 'Public Education',
        permissions: {
            read: false,
            write: false,
            delete: false
        }
    },
    deployments: {
        label: 'Deployments',
        permissions: {
            read: false,
            write: false,
            approve: false,
            delete: false
        }
    },
    // #1482: member HR records (discipline letters, commendations, driver's
    // abstracts, criminal record checks). Deliberately NOT reusing `records.*`,
    // which defaults to true for every member. All three default false — HR is
    // the most sensitive data in the system and is granted individually, never
    // by the role ladder (see src/data/permissionRoles.js).
    hr: {
        label: 'HR',
        permissions: {
            read: false,
            write: false,
            delete: false
        }
    },
    // #2295: OH&S meeting minutes. Readable by default because workers are
    // entitled to see what their joint committee recorded; recording a meeting
    // is an officer job.
    ohs: {
        label: 'OH&S',
        permissions: {
            read: true,
            write: false,
            delete: false
        }
    }
};

const DefaultPermissions = Object.keys(Permissions).reduce((acc, group) => {
    const {permissions = {}} = Permissions[group] || {};

    Object.keys(permissions).forEach(permission => {
        acc[`${group}.${permission}`] = permissions[permission];
    });

    return acc;
}, {});

const IncidentTypes = {
    MVI: 'Motor Vehicle Incident',
    FMR: 'First Medical Response',
    BURNING_COMPLAINT: 'Burning Complaint',
    LINE_DOWN: 'Line Down',
    ASSIST: 'Assist',
    STRUCTURE_FIRE: 'Structure Fire',
    WILDLAND_FIRE: 'Wildland Fire',
    VEHICLE_FIRE: 'Vehicle Fire',
    MISC_FIRE: 'Miscellaneous Fire',
    ALARM: 'Alarm',
    RECHECK: 'Recheck',
    RESCUE: 'Rescue',
    SERVICE_CALL: 'Service Call',
    MUTUAL_AID: 'Mutual Aid',
    HAZMAT: 'Hazmat',
    PUBLIC_SERVICE: 'Public Service',
    UNKNOWN: 'Unknown'
};

const IncidentStatuses = {
    PENDING_IMPORT: 'Pending Import',
    IN_PROGRESS: 'In Progress',
    AWAITING_REVIEW: 'Awaiting Review',
    REJECTED: 'Rejected',
    LOCKED: 'Approved & Locked'
};

const LockedIncidentStatuses = ['LOCKED'];

// Single source of truth for "does this incident count toward statistics and
// reports?" (#1168). An incident counts only when it is finalized — Approved &
// Locked — or is a legacy record created before the status workflow existed (no
// `status` field; bin/migrate-incident-status.js backfills those to LOCKED, and
// counting missing-status keeps un-migrated tenants from being undercounted).
// In-progress, awaiting-review, pending-import and rejected incidents are
// excluded: they are still being documented or were thrown out, so counting
// them would make totals unstable or overstated. Every incident aggregate — the
// Incident Summary report, the nightly dashboardStats, and the per-user
// incidentStats / incidentTotals triggers — routes through this so they can't
// drift apart. Note `status` stores the status *key* ('LOCKED'), not its display
// string.
const isCountableIncident = incident =>
    !!incident && (!incident.status || LockedIncidentStatuses.includes(incident.status));

// Training's approval workflow (#2330) is the incident one without
// PENDING_IMPORT: nothing imports a training record, so every one starts In
// Progress. It is opt-in per department
// (`settings/general.requireTrainingApprovalForPayroll`), and only payroll reads
// it — attendance, stats and competencies count a record as soon as it's saved.
const TrainingStatuses = {
    IN_PROGRESS: 'In Progress',
    AWAITING_REVIEW: 'Awaiting Review',
    REJECTED: 'Rejected',
    LOCKED: 'Approved & Locked'
};

const LockedTrainingStatuses = ['LOCKED'];

// Does this training record's time count toward payroll? Always, unless the
// department requires approval — and then only once it is Approved & Locked.
// A record with no `status` predates the setting (records are only given one
// while it is on), so it still counts: turning the setting on never changes a
// report that has already been run. Session rows carry their parent's status
// (sessionRow spreads the parent), so this works on either shape.
const isPayableTraining = (record, settings) => {
    if (!record) return false;
    if (settings?.requireTrainingApprovalForPayroll !== true) return true;
    return !record.status || LockedTrainingStatuses.includes(record.status);
};

// A BCWS deployment has two distinct endings: the truck came home (operations
// over) and the reimbursement package is filed (record final). COMPLETED covers
// the first — the apparatus stops reading as deployed but the record stays
// editable so DTRs/214s/receipts can keep landing. LOCKED covers the second.
const DeploymentStatuses = {
    ACTIVE: 'Active',
    COMPLETED: 'Completed',
    LOCKED: 'Locked'
};

// Terminal state — the record is final and read-only. Mirrors
// LockedIncidentStatuses so callers test membership, not strings.
const LockedDeploymentStatuses = ['LOCKED'];

const DeploymentRoles = {
    crewLeader: 'Crew Leader',
    spCrewMember: 'Structural Protection Crew Member',
    apparatusMember: 'Apparatus Member'
};

// `iap` is the Incident Action Plan issued for an operational period — a
// first-class BCWS document the crew works from, so it gets its own bucket
// rather than disappearing into `other`. Unlike DTRs/214s it isn't authored by
// the crew (it's handed down), so it is never treated as required paperwork.
const DeploymentFileGroupings = {
    receipts: 'Receipts',
    dtrs: 'DTRs',
    forms214: 'ICS 214s',
    iap: 'IAPs',
    other: 'Other'
};

// Per-day state of an unmanned SPU, recorded in
// `deployments/{id}.dayDetails[rotationId][YYYY-MM-DD].spuState`. This replaces
// the DTR/214 requirement on an equipment-only rotation — it is what BCWS bills
// on (see SPU_RATE_CODES in data/bcws/deploymentTypes.mjs).
const DeploymentEquipmentStates = {
    OPEN: 'Open',
    CLOSED: 'Closed'
};

const DeploymentReceiptCategories = {
    fuel: 'Fuel',
    lodging: 'Lodging',
    food: 'Food',
    other: 'Other'
};

const ApparatusCheckStatuses = {
    AWAITING_REVIEW: 'Awaiting Review',
    APPROVED: 'Approved'
};

const GearCheckTypes = {
    inspection: 'Inspection',
    weekly: 'Weekly',
    full: 'Full'
};

const CheckFrequencies = {
    WEEKLY: 'Weekly',
    MONTHLY: 'Monthly',
    QUARTERLY: 'Quarterly',
    SEMIANNUALLY: 'Every 6 months',
    YEARLY: 'Yearly'
};

const CheckFrequencyDurations = {
    WEEKLY: {value: 1, unit: 'weeks'},
    MONTHLY: {value: 1, unit: 'months'},
    QUARTERLY: {value: 3, unit: 'months'},
    SEMIANNUALLY: {value: 6, unit: 'months'},
    YEARLY: {value: 1, unit: 'years'}
};

const ApparatusCheckTypes = {
    weekly: 'Weekly',
    full: 'Full',
    maintenance: 'Maintenance',
    bcwsReadiness: 'BCWS Readiness'
};

// Checks that belong to the hall itself rather than to a truck or a gear
// category (#1920): the siren, the generator, extinguisher tags by room, the
// eye-wash station. Departments add their own types through the same "Add New
// Check" prompt apparatus uses, so this is a starting vocabulary, not a closed
// set — SPVFD's duty-driver sheets are a weekly hall check plus a monthly
// maintenance one (#1913).
const StationCheckTypes = {
    weekly: 'Weekly',
    maintenance: 'Maintenance'
};

const RecordTypes = {
    MAINTENANCE: 'Maintenance',
    CLEANING: 'Cleaning',
    INSPECTION: 'Inspection',
    REPAIR: 'Repair',
    REFILL: 'Refill'
};

const ApparatusRecordTypes = {
    MAINTENANCE: 'Maintenance',
    INSPECTION: 'Inspection',
    REPAIR: 'Repair',
    SERVICE: 'Service',
    OTHER: 'Other'
};

// #1482: member HR records. No LEAVE_OF_ABSENCE — leave lives in the status-change
// workflow (#1516), not here.
const MemberRecordTypes = {
    DISCIPLINE: 'Discipline',
    COMMENDATION: 'Commendation',
    SERVICE_AWARD: 'Service Award',
    PROMOTION: 'Promotion',
    DRIVERS_ABSTRACT: 'Driver\'s Abstract',
    CRIMINAL_RECORD_CHECK: 'Criminal Record Check',
    NOTE: 'Note',
    OTHER: 'Other'
};

// Types the member must not see on their own profile unless an HR user
// deliberately unticks `confidential`. Everything else (commendations, awards,
// promotions) is benign and self-visible by default.
const ConfidentialMemberRecordTypes = ['DISCIPLINE', 'DRIVERS_ABSTRACT', 'CRIMINAL_RECORD_CHECK', 'NOTE'];

// Types where the attachment IS the record. A driver's abstract with no scan
// attached is an unevidenced assertion — the whole point of filing one is to hold
// the document. Enforced by the record dialog (the api can't: attachments are
// uploaded after the record doc exists, so it has an id to attach them to).
const MemberRecordTypesRequiringFile = ['DRIVERS_ABSTRACT'];

const memberRecordRequiresFile = type => MemberRecordTypesRequiringFile.includes(type);

// Single source of truth for "is this record hidden from the member". The api
// filters self-views with it and the client renders its lock chip from it, so
// the two can't drift. An explicit per-record `confidential` boolean always wins
// over the type default (either direction).
const isConfidentialMemberRecord = record => {
    const {confidential, type} = record || {};
    if (typeof confidential === 'boolean') return confidential;
    return ConfidentialMemberRecordTypes.includes(type);
};

const TrainingTypes = {
    PRACTICE: 'Practice',
    EXTRA_PRACTICE: 'Extra Practice',
    EXTERNAL_COURSE: 'Course (External)',
    INTERNAL_COURSE: 'Course (Internal)',
    OFFICER_MEETING: 'Officer Meeting',
    SOCIAL: 'Social',
    OHS_MEETING: 'OH&S Meeting'
};

// OH&S meetings (#2295) are training records so their attendance is paid and
// shows in a member's history, but they're recorded on their own page (behind
// the `ohs` feature and the `ohs.*` permissions), not the training form, and are
// kept out of training's own lists, stats and competency coverage.
const OHS_MEETING_TYPE = 'OHS_MEETING';

const isOhsMeeting = record => record?.type === OHS_MEETING_TYPE;

// Where a training record opens. A session row carries its parent's id as
// `recordId`.
const trainingRecordPath = (record, id = record?.recordId || record?.id || record?.uid) => (
    `/${isOhsMeeting(record) ? 'ohs' : 'training'}/${id}`
);

// The types the training form offers. Not OH&S: picking it there would file a
// meeting the OH&S page's designee never sees.
const SelectableTrainingTypes = Object.keys(TrainingTypes).filter(type => type !== OHS_MEETING_TYPE);

// An OH&S meeting is a paid hall obligation like an officer meeting, so its
// hours land in the same practice bucket.
const PracticeTrainingTypes = ['PRACTICE', 'EXTRA_PRACTICE', 'OFFICER_MEETING', 'SOCIAL', 'OHS_MEETING'];

// Training whose attendance reflects a member's own turnout, which is the only
// thing a performance review can fairly grade. Deliberately narrower than
// PracticeTrainingTypes (payroll's hours split, which also counts officer and
// OH&S meetings): a meeting is a rank's obligation and a course runs on enrolment, so
// marking a firefighter absent from either measures the schedule, not them.
const AttendanceTrainingTypes = ['PRACTICE', 'EXTRA_PRACTICE', 'SOCIAL'];

const DutyShiftTypes = {
    duty: 'Duty',
    standby: 'Standby',
    bcwsIaStandby: 'BCWS Initial Attack Crew Standby',
    unavailable: 'Unavailable',
    other: 'Other'
};

// The `other` type exists so a department can schedule something this fixed list
// doesn't name (a marine watch, a fireworks standby, a parade detail) without
// waiting on a release. Such a shift carries its own name in `typeLabel`.
const DUTY_SHIFT_TYPE_OTHER = 'other';

// A duty shift's type as it should be displayed — the one place that knows
// `typeLabel` overrides the built-in name, so the list, the calendars, the ICS
// feed, payroll and the breadcrumb can't drift apart. `fallback` is what to show
// when the shift has no type at all (a grid cell wants '', a calendar entry
// wants 'Duty Shift').
const dutyShiftTypeLabel = (shift, fallback = '') => {
    const {type, typeLabel} = shift || {};
    const custom = typeof typeLabel === 'string' ? typeLabel.trim() : '';

    if (type === DUTY_SHIFT_TYPE_OTHER && custom) {
        return custom;
    }

    return DutyShiftTypes[type] || type || fallback;
};

// How a duty shift is NAMED on a report: its type, and the preset window it was
// scheduled from when it has one ("Standby · Night").
//
// Shared because payroll's member breakdown and the duty shift attendance grid
// had each built this string themselves, and had already diverged on the
// fallback — a shift with no type at all read "Duty Shift" on one and empty on
// the other. `fallback` is what to show when there is no type: a grid cell wants
// '', a line on someone's hours breakdown wants 'Duty Shift'.
const dutyShiftDisplayName = (shift, fallback = '') => {
    const label = dutyShiftTypeLabel(shift, fallback);
    const preset = shift && typeof shift.preset === 'string' ? shift.preset.trim() : '';

    if (!preset) {
        return label;
    }

    // A preset on a shift with no resolvable type would otherwise render as a
    // leading separator (" · Night"), so the preset stands alone.
    return label ? `${label} · ${preset}` : preset;
};

// Named duty-shift presets, each a labelled time window ("HH:mm" start/end on a
// 24h clock). A window whose end is not after its start crosses midnight onto
// the following day (e.g. a Night preset 20:00 -> 08:00, or a 24h block such as
// 18:00 -> 18:00). Tenants configure their own list in settings/general under
// `dutyShiftPresets`; these are the defaults when none are configured.
const DefaultDutyShiftPresets = [
    {label: 'Day', start: '08:00', end: '20:00'},
    {label: 'Night', start: '20:00', end: '08:00'}
];

// ---- repeating duty shifts (gh #1337) --------------------------------------
//
// Shared by the drawer (which materialises a series on save) and the api's
// extendDutyShiftSeries job (which tops open-ended series up), so the two step
// occurrences identically. Callers pass moments in the zone the shift is
// scheduled in — the browser's local zone, or America/Vancouver on the api —
// and the week arithmetic is zone-aware, so a Friday 18:00 start stays 18:00
// across a DST boundary.

// Volunteer departments that run a crew rotation schedule the same window every
// N weeks — Lions Bay runs four weekend crews (A/B/C/D), so each crew's Friday
// 18:00 -> Monday 06:00 shift comes round every 4th week. Rather than a general
// recurrence grammar, the drawer offers the handful of week-multiples a rotation
// actually uses; anything else is still a one-off shift.
const DUTY_SHIFT_REPEAT_OPTIONS = [
    {value: 0, label: 'Does not repeat'},
    {value: 1, label: 'Every week'},
    {value: 2, label: 'Every 2 weeks'},
    {value: 3, label: 'Every 3 weeks'},
    {value: 4, label: 'Every 4 weeks'},
    {value: 6, label: 'Every 6 weeks'},
    {value: 8, label: 'Every 8 weeks'}
];

// Hard ceiling on how many docs one materialisation may write. Each occurrence
// is its own dutyShifts doc (payroll counts the per-shift stipend per doc, so a
// series can never be one long doc) and they go out in a single batch — 104 is
// two years of weekly shifts, or eight years of a 4-weekly rotation, and still
// far inside Firestore's 500-write batch limit.
const MAX_DUTY_SHIFT_OCCURRENCES = 104;

// How far ahead an open-ended ("Never" ends) series is materialised. The nightly
// extendDutyShiftSeries job tops every open series back up to this horizon, so
// "forever" is a rolling window of real docs rather than a rule evaluated at read
// time — which is what payroll, attendance and attachments all need. Twelve
// months keeps even a weekly series (52 docs) inside the cap above.
const DUTY_SHIFT_OPEN_ENDED_HORIZON_MONTHS = 12;

// The date an open-ended series should currently be materialised through.
const openEndedHorizon = from => moment(from).add(DUTY_SHIFT_OPEN_ENDED_HORIZON_MONTHS, 'months').endOf('day');

const repeatIntervalLabel = intervalWeeks => {
    const option = DUTY_SHIFT_REPEAT_OPTIONS.find(o => o.value === Number(intervalWeeks));
    return option ? option.label : `Every ${intervalWeeks} weeks`;
};

// Expand a single shift window into the series it repeats as: the original plus
// one copy every `intervalWeeks` weeks, up to and including the last one that
// STARTS on or before `until` (end of that day).
//
// Both endpoints are shifted by the same number of weeks rather than the end
// being re-derived from a duration, so a shift keeps its wall-clock hours across
// a DST boundary — a Friday 18:00 start stays 18:00, not 17:00, and a window
// that crosses midnight (or a whole weekend) keeps its shape.
//
// Returns `[]` when the window isn't complete, and `[window]` when there's no
// repeat — so callers can always treat the result as the list of shifts to write.
const buildRepeatWindows = ({start, end, intervalWeeks, until, max = MAX_DUTY_SHIFT_OCCURRENCES} = {}) => {
    if (start == null || end == null) return [];

    const first = {start: moment(start), end: moment(end)};
    if (!first.start.isValid() || !first.end.isValid()) return [];

    const interval = Number(intervalWeeks) || 0;
    const untilMoment = until == null ? null : moment(until);
    if (interval <= 0 || !untilMoment || !untilMoment.isValid()) return [first];

    const lastStart = untilMoment.clone().endOf('day');
    const windows = [first];

    for (let index = 1; index < max; index++) {
        const nextStart = first.start.clone().add(interval * index, 'weeks');
        if (nextStart.isAfter(lastStart)) break;

        windows.push({start: nextStart, end: first.end.clone().add(interval * index, 'weeks')});
    }

    return windows;
};

const OccupancyTypes = {
    RESIDENTIAL_SINGLE: 'Residential - Single Family',
    RESIDENTIAL_MULTI: 'Residential - Multi-Family',
    COMMERCIAL: 'Commercial',
    INDUSTRIAL: 'Industrial',
    INSTITUTIONAL: 'Institutional',
    ASSEMBLY: 'Assembly',
    EDUCATIONAL: 'Educational',
    HEALTHCARE: 'Healthcare',
    AGRICULTURAL: 'Agricultural',
    STORAGE: 'Storage',
    MIXED_USE: 'Mixed Use',
    OTHER: 'Other'
};

const ConstructionTypes = {
    TYPE_I: 'Type I - Fire-Resistive',
    TYPE_II: 'Type II - Non-Combustible',
    TYPE_III: 'Type III - Ordinary',
    TYPE_IV: 'Type IV - Heavy Timber',
    TYPE_V: 'Type V - Wood Frame'
};

const TrainingDisciplines = {
    EXTERIOR: 'Exterior',
    INTERIOR: 'Interior',
    FR: 'FR',
    ROPES: 'Ropes',
    WILDLAND: 'Wildland',
    AUTOX: 'AutoX',
    HAZMAT: 'Hazmat',
    CISM: 'CISM',
    OFFICER: 'Officer',
    DRIVER_OPERATOR: 'Driver/Operator',
    OTHER: 'Other'
};

const TaskStatuses = {
    OPEN: 'Open',
    COMPLETE: 'Complete'
};

const TaskFrequencies = {
    WEEKLY: 'Weekly',
    MONTHLY: 'Monthly',
    QUARTERLY: 'Quarterly',
    SEMIANNUALLY: 'Semi-annually',
    YEARLY: 'Yearly'
};

// Recurring payroll cadences (#1101). A department configures a cadence plus a
// "start date"; every period boundary is computed by stepping the interval
// forward from that date. Steps are anchor-relative — never calendar-quarter
// aligned — so a quarterly department whose periods run mid-month (e.g.
// Mar 16 – Jun 15) lands on the right days.
const PayrollCadences = {
    biweekly: {label: 'Bi-weekly', step: {amount: 14, unit: 'days'}},
    quarterly: {label: 'Quarterly', step: {amount: 3, unit: 'months'}}
};

// First period whose START falls on or after `fromDate`, stepping the cadence
// forward from `anchorDate` (the configured start date). Returns {startDate,
// endDate} as 'YYYY-MM-DD' strings — date-only and timezone-agnostic, so the
// caller applies its own start/end-of-day normalization (the api snaps them to
// America/Vancouver day boundaries, matching manual period creation). A period
// spans [start, start + step - 1 day] inclusive.
//
// Inputs are normalized to bare calendar dates before stepping so a stored
// Timestamp/ISO string with a time-of-day component can't drift the result by a
// day. Pass `fromDate` = the day after the latest period's start to get the
// next period, or omit it to get the very first (anchor) period.
const nextPayrollPeriod = (cadence, anchorDate, fromDate) => {
    const config = PayrollCadences[cadence];
    if (!config) throw new Error(`Unknown payroll cadence: ${cadence}`);
    const {amount, unit} = config.step;
    if (!(amount > 0)) throw new Error(`Invalid payroll cadence step for "${cadence}"`);

    const toCalendarDate = value => moment(moment(value).format('YYYY-MM-DD'), 'YYYY-MM-DD');

    const anchor = toCalendarDate(anchorDate);
    if (!anchor.isValid()) throw new Error('nextPayrollPeriod: invalid anchorDate');
    const from = fromDate != null ? toCalendarDate(fromDate) : anchor.clone();
    if (!from.isValid()) throw new Error('nextPayrollPeriod: invalid fromDate');

    const start = anchor.clone();
    let guard = 0;
    while (start.isBefore(from, 'day')) {
        start.add(amount, unit);
        // Anchor-relative stepping can't loop forever for a sane fromDate, but
        // guard against a pathological far-future date rather than spin.
        if (++guard > 200000) throw new Error('nextPayrollPeriod: step overflow');
    }
    const end = start.clone().add(amount, unit).subtract(1, 'day');
    return {startDate: start.format('YYYY-MM-DD'), endDate: end.format('YYYY-MM-DD')};
};

// A known bi-weekly period start (a Sunday) from North Shore's real pay
// calendar. Bi-weekly cycles have an arbitrary fortnightly *phase* that can't be
// derived — it has to come from a department's actual calendar. North Shore's
// runs on these Sundays (…, Mar 1, Mar 15, Mar 29, …); we use it to phase-align
// the no-start-date default so the common case matches without configuration.
// Departments on a different fortnight simply set their own start date.
const BIWEEKLY_PHASE_REFERENCE = '2026-03-15';

// Default grid anchor when a department hasn't configured a start date (#1101).
// Bi-weekly aligns to whole weeks (Sunday start) AND to North Shore's fortnight
// phase: the Sunday on/before Jan 1, nudged by a week if needed so the grid
// lands on North Shore's cycle (e.g. 2026 → Jan 4, giving …, Mar 15–28, …).
// Quarterly falls back to calendar quarters (Jan 1 / Apr 1 / Jul 1 / Oct 1), so
// it anchors to Jan 1 itself. Returns a JS Date for the reference year (defaults
// to the current year).
const defaultPayrollAnchor = (cadence, referenceDate) => {
    const ref = referenceDate != null ? moment(referenceDate) : moment();
    const year = ref.isValid() ? ref.year() : moment().year();
    const jan1 = moment([year, 0, 1]);
    if (cadence === 'biweekly') {
        const sunday = jan1.clone().startOf('week');
        const reference = moment(BIWEEKLY_PHASE_REFERENCE, 'YYYY-MM-DD');
        // Both are Sundays, so the week diff is a whole number; an odd diff means
        // this Sunday is on the opposite fortnight — shift a week to re-align.
        if (Math.abs(sunday.diff(reference, 'weeks')) % 2 === 1) {
            sunday.add(1, 'week');
        }
        return sunday.toDate();
    }
    return jan1.startOf('day').toDate();
};

// Returns the configured anchor when set, otherwise the smart default for the
// cadence. Use this everywhere a grid is computed so the create dialog, preview,
// and scheduler all agree on the fallback.
const resolvePayrollAnchor = (cadence, anchorDate, referenceDate) =>
    (anchorDate != null && moment(anchorDate).isValid())
        ? anchorDate
        : defaultPayrollAnchor(cadence, referenceDate);

// The department's sequential pay-period number for a period start — the "PP"
// half of the RDCK pay-period code (#1519), e.g. {year: 2026, number: 13} for
// the 13th bi-weekly period of 2026. Period 01 of a year is the first period on
// the cadence grid whose start falls in that year; numbering restarts each
// January.
//
// The grid index is anchor-relative and may be negative (a period that predates
// the configured start date), and Math.round snaps an off-grid custom period to
// the nearest grid slot — same contract as payrollPeriodName. Counting backwards
// from the snapped start (rather than index % 26) makes the 364-day bi-weekly
// drift, and the occasional 27-period year, fall out for free; it also gives
// quarterly the same Q1–Q4 numbering relative to a non-calendar anchor.
//
// Returns null for an unknown cadence or unparseable dates.
const payPeriodNumber = (cadence, anchorDate, startDate) => {
    const config = PayrollCadences[cadence];
    if (!config) return null;
    // moment(undefined) is *now*, so a missing date would otherwise silently
    // resolve to today's period — reject it rather than stamp the wrong code.
    if (anchorDate == null || startDate == null) return null;

    const toCalendarDate = value => moment(moment(value).format('YYYY-MM-DD'), 'YYYY-MM-DD');
    const anchor = toCalendarDate(anchorDate);
    const start = toCalendarDate(startDate);
    if (!anchor.isValid() || !start.isValid()) return null;

    const {amount, unit} = config.step;
    if (!(amount > 0)) return null;

    const steps = unit === 'months'
        ? start.diff(anchor, 'months') / amount
        : start.diff(anchor, 'days') / amount;
    const index = Math.round(steps);
    const gridStart = anchor.clone().add(index * amount, unit);

    const year = gridStart.year();
    const cursor = gridStart.clone();
    let number = 1;
    while (true) {
        cursor.subtract(amount, unit);
        if (cursor.year() !== year) break;
        number++;
        // A year can't hold more grid periods than days; guard rather than spin
        // if a future cadence ever has a zero-length step.
        if (number > 400) break;
    }

    return {year, number};
};

// A short, human-readable tag for a period at grid `index` (0 = the anchor
// period), measured against the grid `anchor`. Quarterly cycles Q1–Q4 relative
// to the configured start date (not calendar quarters); bi-weekly reads
// "Period 15, 2026" — the sequential pay period within the year.
//
// Bi-weekly used to be labelled by the ISO week its start fell in ("Week 30,
// 2026"), which was roughly double the number payroll actually refers to and
// disagreed with the pay-period code on the RDCK export's worksheet tab. Both
// now come from payPeriodNumber, so the label and the form always match.
const payrollPeriodTag = (cadence, index, start, anchor) => {
    if (cadence === 'quarterly') {
        return `Q${(index % 4) + 1} ${start.year()}`;
    }
    if (cadence === 'biweekly') {
        const period = payPeriodNumber(cadence, anchor, start);
        if (period) return `Period ${period.number}, ${period.year}`;
    }
    return `Period ${index + 1}`;
};

// Windowed list of periods for the manual "Create Payroll Report" picker
// (#1101). Returns the recent elapsed periods plus the next upcoming one,
// most-recent-first, each as {startDate, endDate, index, tag} — where index is
// the 0-based offset from the anchor and startDate/endDate are 'YYYY-MM-DD'
// strings (caller normalizes to its own day boundaries). `past`/`future` control
// how many elapsed / upcoming periods to include around `now`.
const payrollPeriodOptions = (cadence, anchorDate, {now = new Date(), past = 6, future = 1} = {}) => {
    const config = PayrollCadences[cadence];
    if (!config) throw new Error(`Unknown payroll cadence: ${cadence}`);
    const {amount, unit} = config.step;
    if (!(amount > 0)) throw new Error(`Invalid payroll cadence step for "${cadence}"`);

    const toCalendarDate = value => moment(moment(value).format('YYYY-MM-DD'), 'YYYY-MM-DD');
    const anchor = toCalendarDate(anchorDate);
    if (!anchor.isValid()) throw new Error('payrollPeriodOptions: invalid anchorDate');
    const nowCal = toCalendarDate(now);

    // Walk the grid from the anchor, collecting periods until we've included
    // `future` periods that start strictly after now (the upcoming ones).
    const all = [];
    let start = anchor.clone();
    let index = 0;
    let upcoming = 0;
    let guard = 0;
    while (true) {
        const end = start.clone().add(amount, unit).subtract(1, 'day');
        all.push({index, start: start.clone(), end});
        if (start.isAfter(nowCal, 'day')) {
            upcoming++;
            if (upcoming >= future) break;
        }
        start = start.clone().add(amount, unit);
        index++;
        if (++guard > 200000) break;
    }

    // Keep only the window: `past` elapsed + current + `future` upcoming.
    const window = all.slice(Math.max(0, all.length - (past + future + 1)));

    return window
        .map(p => ({
            startDate: p.start.format('YYYY-MM-DD'),
            endDate: p.end.format('YYYY-MM-DD'),
            index: p.index,
            tag: payrollPeriodTag(cadence, p.index, p.start, anchor)
        }))
        .reverse();
};

// Human-readable name for a period given its cadence, the grid anchor, and its
// start date — e.g. "Q1 2026" (quarterly) or "Period 6, 2026" (bi-weekly). Used
// to stamp a `name` on created periods (#1101) so the list can show
// "Q1 2026: <range>". Derives the grid index from anchor→start so the quarter
// number is correct even for anchor-relative (non-calendar) quarters. Returns
// null for an unknown cadence or unparseable dates (callers omit the name).
const payrollPeriodName = (cadence, anchorDate, startDate) => {
    const config = PayrollCadences[cadence];
    if (!config) return null;

    const toCalendarDate = value => moment(moment(value).format('YYYY-MM-DD'), 'YYYY-MM-DD');
    const anchor = toCalendarDate(anchorDate);
    const start = toCalendarDate(startDate);
    if (!anchor.isValid() || !start.isValid()) return null;

    const {amount, unit} = config.step;
    const steps = unit === 'months'
        ? start.diff(anchor, 'months') / amount
        : start.diff(anchor, 'days') / amount;
    const index = Math.max(0, Math.round(steps));
    return payrollPeriodTag(cadence, index, start, anchor);
};

// User-facing groups for the configurable task-reminder toggles (#1043). Each
// group maps to one or more cadence stages in the api's getOutstandingTaskEmails:
//   upcoming → 3 months / 1 month / 1 week / 1 day before
//   due      → the due-day email (sent at the task's time if set)
//   overdue  → the escalating overdue reminders
const TaskReminderStages = {
    upcoming: 'Upcoming reminders',
    due: 'Due-date reminder',
    overdue: 'Overdue reminders'
};

const Ranks = {
    APPARATUS: 'Apparatus',
    EMPLOYEE: 'Employee',
    ADMINISTRATOR: 'Administrator',

    RECRUIT: 'Recruit',
    AUXILIARY: 'Auxiliary',
    EXTERIOR: 'Exterior',
    INTERIOR: 'Interior',
    FULLSERVICE: 'Full Service',

    TEAM_LEADER: 'Team Leader',

    ENGINEER: 'Engineer',
    LIEUTENANT: 'Lieutenant',

    CAPTAIN: 'Captain',
    ASSISTANT_TRAINING_OFFICER: 'Assistant Training Officer',
    TRAINING_OFFICER: 'Training Officer',
    
    ASSISTANT_CHIEF: 'Assistant Chief',
    DEPUTY_CHIEF: 'Deputy Chief',
    CHIEF: 'Chief'
};

const ShortRanks = {
    RECRUIT: 'Recruit',
    AUXILIARY: 'Aux.',
    EXTERIOR: 'FF',
    INTERIOR: 'FF',
    FULLSERVICE: 'FF',
    TEAM_LEADER: 'TL',
    ENGINEER: 'Eng.',
    LIEUTENANT: 'Lt.',
    CAPTAIN: 'Capt.',
    ASSISTANT_TRAINING_OFFICER: 'Ass. TO',
    TRAINING_OFFICER: 'TO',
    ASSISTANT_CHIEF: 'AC',
    DEPUTY_CHIEF: 'DC',
    CHIEF: 'Chief'
};

const FirefighterRanks = [
    'RECRUIT',
    'AUXILIARY',
    'EXTERIOR',
    'INTERIOR',
    'FULLSERVICE',
    'TEAM_LEADER',
    'ENGINEER',
    'LIEUTENANT',
    'CAPTAIN',
    'ASSISTANT_TRAINING_OFFICER',
    'TRAINING_OFFICER',
    'ASSISTANT_CHIEF',
    'DEPUTY_CHIEF',
    'CHIEF'
];

const OfficerRanks = [
    'LIEUTENANT',
    'CAPTAIN',
    'ASSISTANT_TRAINING_OFFICER',
    'TRAINING_OFFICER',
    'ASSISTANT_CHIEF',
    'DEPUTY_CHIEF',
    'CHIEF'
];

const ChiefRanks = [
    'ASSISTANT_CHIEF',
    'DEPUTY_CHIEF',
    'CHIEF'
];

// #1718 — rank ordering, for describing a rank change as a promotion or a
// demotion. These live in `common` (rather than beside a UI helper) because the
// `backfillRankChangeOnUserWrite` trigger in functions/ needs them too.
//
// Only `FirefighterRanks` is an ordered ladder. APPARATUS / EMPLOYEE /
// ADMINISTRATOR are account kinds, not ranks, and 'STATION' isn't in `Ranks` at
// all — a station login. None of them can be placed on the ladder, so every
// helper here says so explicitly rather than defaulting them to the bottom.
//
// Deliberately NOT a refactor of the ~8 ad-hoc rank comparisons elsewhere in the
// codebase — see the follow-up issue.
const rankOrder = rank => {
    const index = FirefighterRanks.indexOf(rank);
    return index === -1 ? null : index;
};

// -1 / 0 / 1 like any comparator, or the string 'unknown' when either side isn't
// on the ladder. The odd return type is deliberate: callers must handle the
// third case, and a numeric sentinel would silently sort as a real rank.
const compareRanks = (a, b) => {
    const left = rankOrder(a);
    const right = rankOrder(b);
    if (left === null || right === null) return 'unknown';
    return Math.sign(left - right);
};

// How a member moved. `from` being empty means this is their first recorded
// rank, which is an appointment rather than a promotion.
const rankChangeDirection = (from, to) => {
    if (!from) return 'initial';

    const compared = compareRanks(from, to);
    if (compared === 'unknown') return 'unknown';
    if (compared < 0) return 'promotion';
    if (compared > 0) return 'demotion';
    return 'lateral';
};

// The pure timeline builder with this department's rank ladder wired in.
const rankTimeline = (rows, options = {}) =>
    rankTimelineRows(rows, {directionOf: rankChangeDirection, ...options});

const MemberStatuses = {
    ACTIVE: 'Active',
    ON_LEAVE: 'On Leave',
    MEDICAL_LEAVE: 'Medical Leave',
    RESIGNED: 'Resigned',
    TERMINATED: 'Terminated'
};

const DisabledStatuses = ['RESIGNED', 'TERMINATED'];

// Statuses where the member is still on the roster but not counted as active —
// they pause an active interval rather than ending it (#1516). Exported so
// `activeIntervals` has a default and a tenant that wants MEDICAL_LEAVE to keep
// counting can override it per call.
const SuspendedStatuses = ['ON_LEAVE', 'MEDICAL_LEAVE'];

const DrivingCodes = {
    ROUTINE: 'Routine',
    CODE3: 'Code 3'
};

// ICBC driver's licence classes (#1624), in the order ICBC lists them. `value` is
// what `users/{uid}.driversLicence.class` stores.
//
// The air brake endorsement (Code 15) is NOT one of these. It's an endorsement on
// the licence, independent of its class — a three-axle truck or a small bus can
// run hydraulic brakes, so Class 1/2/3 without the endorsement is a real licence,
// and a Class 5 motorhome with it is too. Hence `driversLicence.airBrakes` as its
// own boolean rather than a second set of classes.
const LicenceClasses = [
    {value: '1', label: 'Class 1', description: 'Semi-trailer trucks'},
    {value: '2', label: 'Class 2', description: 'Buses, including school buses'},
    {value: '3', label: 'Class 3', description: 'Trucks with more than two axles'},
    {value: '4U', label: 'Class 4 (Unrestricted)', description: 'Buses, taxis and ambulances'},
    {value: '4R', label: 'Class 4 (Restricted)', description: 'Taxis, ambulances and buses up to 25 seats'},
    {value: '5', label: 'Class 5', description: 'Cars, vans and small trucks'},
    {value: '6', label: 'Class 6', description: 'Motorcycles'},
    {value: '7', label: 'Class 7', description: 'Novice — graduated licensing'},
    {value: '7L', label: 'Class 7L', description: 'Learner'},
    {value: '8', label: 'Class 8', description: 'Novice motorcycle'},
    {value: '8L', label: 'Class 8L', description: 'Learner motorcycle'}
];

// Provider-independent certificates. `provincial` contains credentials issued or
// required under BC's minimum-training system; Hazmat Operations is shared too, but is
// an NFPA qualification rather than a provincial one and therefore lives separately.
//
// `oldMappings` keeps names, task links and compatibility reads attached to records
// written before #2325. The migration moves those records to these canonical paths.
const ProvincialSkills = {
    label: 'Provincial Requirements',
    shortLabel: 'Prov',
    extra: true,
    skills: {
        firstAid: {
            label: 'First Aid',
            hasExpiry: true,
            impliedByLevel: false,
            oldMappings: ['exterior.fr3', 'exterior.firstAid', 'truckReady.firstAid']
        },
        ics100: {label: 'ICS 100', oldMappings: ['exterior.ics100', 'truckReady.ics100']},
        trafficControl: {label: 'Traffic Control', width: 130, oldMappings: ['exterior.trafficControl', 'truckReady.trafficControl']},
        whmis: {label: 'WHMIS', oldMappings: ['truckReady.whmis']},
        gasSafety: {label: 'Gas Safety', oldMappings: ['truckReady.gasSafety']},
        electricalSafety: {label: 'Electrical Safety', oldMappings: ['truckReady.electricalSafety']},
        sppWff1: {label: 'WSPP-WFF 1', width: 110, oldMappings: ['exterior.sppWff1']},
        hazmatAwareness: {label: 'HAZMAT Awareness', width: 170, oldMappings: ['exterior.hazmatAwareness', 'truckReady.hazmatAwareness']},
        apparatusDriverOperator: {
            label: 'Driver/Operator',
            width: 130,
            impliedByLevel: false,
            oldMappings: ['exterior.apparatusDriverOperator', 'truckReady.apparatusDriverOperator']
        }
    }
};

const SharedQualificationSkills = {
    // Storage metadata only. Provider catalogues supply the user-facing placement;
    // no surface should expose the internal `shared` category name.
    label: '',
    extra: true,
    storageOnly: true,
    skills: {
        hazmatOps: {
            label: 'HAZMAT Operations',
            width: 130,
            oldMappings: ['fullService.hazmatOps', 'fullService.nfpa1072Hazmat', 'ff2.hazmatOps']
        }
    }
};

const DepartmentQualificationSkills = {
    label: '',
    extra: true,
    storageOnly: true,
    skills: {
        sogs: {
            label: 'SOGs',
            oldMappings: ['truckReady.sogs']
        }
    }
};

const provincialQualificationAlias = (key, overrides = {}) => {
    const {oldMappings: _oldMappings, ...definition} = ProvincialSkills.skills[key];
    return {...definition, skill: `provincial.${key}`, ...overrides};
};

const sharedQualificationAlias = (key, overrides = {}) => {
    const {oldMappings: _oldMappings, ...definition} = SharedQualificationSkills.skills[key];
    return {...definition, skill: `shared.${key}`, ...overrides};
};

const Skills = {
    provincial: ProvincialSkills,
    exterior: {
        label: 'Exterior',
        skills: {
            knowledge: 'Knowledge',
            skills: 'Skills'
        }
    },
    interior: {
        label: 'Interior',
        skills: {
            knowledge: 'Knowledge',
            skills: 'Skills',
            liveFire1: 'Live Fire 1'
        }
    },
    fullService: {
        label: 'Full Service',
        shortLabel: 'FS',
        skills: {
            knowledge: 'Knowledge',
            skills: 'Skills',
            communityService: 'Community Service',
            liveFire2: 'Live Fire 2',
            hazmatOps: sharedQualificationAlias('hazmatOps')
        }
    },
    teamLeader: {
        label: 'Team Leader',
        shortLabel: 'TL',
        skills: {
            esm1: 'ESM 1',
            ics200: 'ICS 200',
            engineBoss: 'Engine Boss'
        }
    },
    fireOfficer1: {
        label: 'Fire Officer 1',
        shortLabel: 'FO 1',
        skills: {
            frontlineLeadership1: {
                label: 'Frontline Leadership 1',
                width: 120
            },
            fireServiceAdmin1: {
                label: 'Fire Service Admin 1',
                width: 110
            },
            companyInspections: {
                label: 'Company Inspections',
                width: 110
            },
            instructor1: 'Instructor 1'
        }
    },
    fireOfficer2: {
        label: 'Fire Officer 2',
        shortLabel: 'FO 2',
        skills: {
            esm2: 'ESM 2',
            frontlineLeadership2: {
                label: 'Frontline Leadership 2',
                width: 120
            },
            fireServiceAdmin2: {
                label: 'Fire Service Admin 2',
                width: 110
            },
            fireCauseAndOrigin1: {
                label: 'Fire Cause & Origin 1',
                width: 110
            },
            ics300: 'ICS 300'
        }
    },
    fireOfficer3: {
        label: 'Fire Officer 3',
        shortLabel: 'FO 3',
        skills: {
            budgetManagement: {
                label: 'Bugdet Management',
                width: 120
            },
            organizationalLeadership1: {
                label: 'Organizational Leadership 1',
                width: 130
            },
            leadingPeople1: {
                label: 'Leading People 1'
            },
            planningAndEvaluation1: {
                label: 'Planning & Evaluation 1',
                width: 110
            },
            ics400: 'ICS 400',
            informationOfficer: {
                label: 'Information Officer',
                width: 110
            }
        }
    },
    fireOfficer4: {
        label: 'Fire Officer 4',
        shortLabel: 'FO 4',
        skills: {
            businessOperations: {
                label: 'Business Operations',
                width: 110
            },
            organizationalLeadership2: {
                label: 'Organizational Leadership 2',
                width: 120
            },
            leadingPeople2: {
                label: 'Leading People 2'
            },
            planningAndEvaluation2: {
                label: 'Planning & Evaluation 2',
                width: 110
            }
        }
    },
    inspectorInvestigator: {
        label: 'Inspector/Investigator',
        width: 180,
        skills: {
            fireInspector1: {
                label: 'Fire Inspector 1',
                width: 110
            },
            fireInspector2: {
                label: 'Fire Inspector 2',
                width: 110
            },
            fireInvestigator: {
                label: 'Fire Investigator',
                width: 110
            }

        }
    },
    rescueTraining: {
        label: 'Rescue Training',
        width: 150,
        extra: true,
        skills: {
            lowAngle: 'Low Angle',
            highAngleOps: {
                label: 'High Angle Ops',
                width: 150
            },
            highAngleTech: {
                label: 'High Angle Technician',
                width: 190
            },
            towerRescue: 'Tower Rescue',
            hazmatTech: {
                label: 'HAZMAT Technician',
                width: 170
            },
            marina: {
                label: 'Marina Firefighting',
                width: 180
            },
            iceRescueTech: {
                label: 'Ice Rescue Technician',
                width: 180
            },
            swiftWaterAwareness: {
                label: 'Swift Water Awareness',
                width: 190
            },
            swiftWaterOps: {
                label: 'Swift Water Ops',
                width: 150
            },
            swiftWaterTech: {
                label: 'Swift Water Technician',
                width: 190
            },
            confinedSpaceAwareness: {
                label: 'Confined Space Awareness',
                width: 220
            },
            confinedSpaceOps: {
                label: 'Confined Space Ops',
                width: 170
            },
            confinedSpaceTech: {
                label: 'Confined Space Technician',
                width: 220
            },
            forcibleEntryAwareness: {
                label: 'Forcible Entry Awareness',
                width: 210
            },
            forcibleEntryOps: {
                label: 'Forcible Entry Ops',
                width: 180
            },
            forcibleEntryTech: {
                label: 'Forcible Entry Technician',
                width: 210
            },
            largeAnimal: {
                label: 'Large Animal Rescue',
                width: 190
            },
            passengerVehicle: {
                label: 'Passenger Vehicle Rescue',
                width: 210
            },
            heavyVehicle: {
                label: 'Heavy Vehicle Rescue',
                width: 190
            },
            advancedAutoEx: {
                label: 'Advanced Auto-Ex',
                width: 170
            }
        }
    },
    wildland: {
        label: 'Wildland',
        extra: true,
        skills: {
            s100: 'S-100',
            s100a: 'S-100A',
            sppWff1: {
                skill: 'provincial.sppWff1'
            },
            spp115: 'WSPP-115',
            s185: {
                label: 'S-185 (Fire Entrapment Avoidance)',
                width: 210
            },
            s190: {
                label: 'S-190 (Safety & Fire Behaviour)',
                width: 210
            },
            s211: {
                label: 'S-211 (Weather & the Fire Environment)',
                width: 210
            },
            s212: {
                label: 'S-212 (Fireline Communications)',
                width: 210
            },
            s290: {
                label: 'S-290 (Intermediate Wildland Fire Behavior)',
                width: 210
            },
            s390: {
                label: 'S-390 (Introduction to Wildland Fire Behavior Calculations)',
                width: 250
            },
            engineBoss: {
                skill: 'teamLeader.engineBoss'
            },
            taskForceLeader: {
                label: 'Task Force Leader',
                search: ['tfl'],
                width: 170
            },
            divisonSupervisor: {
                label: 'Division Supervisor',
                width: 170
            },
            fireSmart101: {
                label: 'FireSmart 101',
                width: 140
            },
            localFireSmartRep: {
                label: 'Local FireSmart Rep.',
                width: 170
            },
            wildfireMitigationSpecialist: {
                label: 'Wildfire Mitigation Specialist',
                width: 210
            },
            fireSmartCoordinator: {
                label: 'FireSmart Coordinator',
                width: 180
            },
            wildfireRiskReduction: {
                label: 'Wildfire Risk Reduction',
                width: 180
            }
        }
    },
    education: {
        label: 'Education',
        extra: true,
        skills: {
            EMR: 'EMR',
            fireServiceInstructor2: {
                label: 'Fire Service Instructor 2',
                width: 190
            },
            fireAndLifeSafetyEducator1: {
                label: 'Fire & Life Safety Educator 1',
                width: 210
            },
            firstResponderInstructor: {
                label: 'FR Instructor',
                width: 120
            },
            emrInstructor: {
                label: 'EMR Instructor',
                width: 130
            },
            sppWff1Instructor: {
                label: 'WSPP-WFF 1 Instructor',
                width: 190
            },
            emergencyVehicleRegulations: {
                label: 'Emergency Vehicle Driving Regulations',
                shortLabel: 'Emerg. Vehicle Reg.',
                width: 210
            }
        }
    },
    alternativeFuelVehicles: {
        label: 'Alternative Fuel Vehicles',
        width: 200,
        extra: true,
        skills: {
            pleasureCraft: {
                label: 'Pleasure Craft',
                width: 130
            },
            smallNonPleasureVesselBasicSafety: {
                label: 'Small Non-Pleasure Vessel Basic Safety',
                width: 240
            },
            smallVesselOperatorProficiency: {
                label: 'Small Vessel Operator Proficiency',
                width: 260
            },
            atvTraining: {
                label: 'ATV Training',
                width: 120
            },
            utilityVehicleTraining: {
                label: 'Utility Vehicle Training',
                width: 180
            },
            alternativeFuelVehicles: {
                label: 'Alternative Fuel Vehicles',
                width: 210
            },
            alternativeFuelVehiclesInstructor: {
                label: 'Alternative Fuel Vehicles Instructor',
                width: 260
            }
        }
    },
    drones: {
        label: 'Drones',
        extra: true,
        skills: {
            basic: {
                label: 'Basic Operations',
                width: 140
            },
            advanced: {
                label: 'Advanced Operations',
                width: 180
            }
        }
    },
    ptsd: {
        label: 'PTSD',
        extra: true,
        skills: {
            assistingIndividuals: {
                label: 'Assisting Individuals In Crisis',
                width: 220
            },
            resilientMinds: {
                label: 'Resilient Minds',
                width: 140
            },
            resilientMindsInstructor: {
                label: 'Resilient Minds Instructor',
                width: 200
            }
        }
    },
    fitTesting: {
        label: 'Fit Testing',
        extra: true,
        skills: {
            fitTesting: {
                label: 'Fit Testing',
                width: 110
            },
            fitTestingInstructor: {
                label: 'Fit Testing Instructor',
                width: 170
            }
        }
    },
    scottSCBA: {
        label: '3M Scott',
        extra: true,
        skills: {
            certifiedTechnician1: {
                label: 'SCBA Certified Technician 1',
                width: 220
            },
            certifiedTechnician2: {
                label: 'SCBA Certified Technician 2',
                width: 240
            }
        }
    },
    jibc: {
        label: 'JIBC',
        extra: true,
        skills: {
            // This category post-dates the credential: departments recorded the JIBC
            // evaluator ticket under Education until it got its own block, leaving
            // `skills.education.jibcEvaluator` on every user doc that had it. That
            // stale copy raised a second expiry task and a second overdue email for one
            // credential (#529); no tenant carries it any more, and `oldMappings` is
            // what names the path if one ever turns up again (a restored backup, an
            // import). It is read for LABELS only — the expiry trigger still keys tasks
            // off the raw path, so a future rename needs that taught to collapse too.
            evaluator: {
                label: 'Evaluator',
                hasExpiry: true,
                oldMappings: ['education.jibcEvaluator']
            }
        }
    },
    viera: {
        label: 'VIERA',
        extra: true,
        skills: {
            evaluator: {
                label: '1001 Evaluator',
                width: 150
            },
            writtenProctor: {
                label: 'Written Proctor',
                width: 150
            },
            practicalProctor: {
                label: 'Practical Proctor',
                width: 150
            }
        }
    },
    eoc: {
        label: 'EOC',
        extra: true,
        skills: {
            ops: 'Ops',
            planning: 'Planning',
            logistics: 'Logistics',
            finance: 'Finance',
            informationOfficer: {
                label: 'Information Officer',
                width: 170
            },
            intro: 'EOC Intro',
            essentials: {
                label: 'EOC Essentials',
                width: 140
            }
        }
    },
    iso: {
        label: 'Incident Safety Officer',
        extra: true,
        width: 190,
        skills: {
            iso: {
                label: 'Incident Safety Officer',
                width: 190
            }
        }
    },
    shared: SharedQualificationSkills,
    department: DepartmentQualificationSkills
};

// The original VIERA catalogue was built for RDCK and includes its local onboarding
// rung. Keep it intact for existing departments; the generic VIERA catalogue below
// presents only the provider curriculum.
const VieraRdckSkills = {
    truckReady: {
        label: 'Truck Ready',
        shortLabel: 'TR',
        skills: {
            // `requiredForLevel: false` — RDCK's HR orientation is district administration
            // rather than a firefighting qualification, and it's the one entry here that
            // isn't provincial: gating Exterior sign-off on it would hard-block every
            // non-RDCK VIERA department (#1450). Still tracked on the matrix as before.
            rdckHr: {label: 'HR', group: 'rdck', groupLabel: 'RDCK', requiredForLevel: false},
            sogs: {
                label: 'SOGs',
                group: 'prov',
                groupLabel: 'Provincial Requirements',
                skill: 'department.sogs',
                requiredForLevel: true
            },
            whmis: provincialQualificationAlias('whmis', {group: 'prov', groupLabel: 'Provincial Requirements'}),
            gasSafety: provincialQualificationAlias('gasSafety', {group: 'prov', groupLabel: 'Provincial Requirements'}),
            electricalSafety: provincialQualificationAlias('electricalSafety', {group: 'prov', groupLabel: 'Provincial Requirements'}),
            trafficControl: provincialQualificationAlias('trafficControl', {group: 'prov', groupLabel: 'Provincial Requirements'}),
            apparatusDriverOperator: provincialQualificationAlias('apparatusDriverOperator', {group: 'prov', groupLabel: 'Provincial Requirements'}),
            hazmatAwareness: provincialQualificationAlias('hazmatAwareness', {group: 'prov', groupLabel: 'Provincial Requirements'}),
            ch1FireService: {label: 'The Fire Service', theoryOnly: true, exam: 1, chapter: 1},
            ch4Comms: {label: 'Fire Service Comms', width: 120, theoryPractical: true, exam: 1, chapter: 4},
            ch2Safety: {label: 'FF Health & Safety', theoryPractical: true, exam: 2, chapter: 2},
            ch3Ppe: {label: 'PPE & SCBA', theoryPractical: true, exam: 2, chapter: 3}
        }
    },
    exterior: {
        label: 'Exterior Operations',
        shortLabel: 'Exterior',
        skills: {
            ch14Water: {label: 'Water Supply', theoryPractical: true, exam: 3, chapter: 14},
            ch15Hose: {label: 'Hose & Nozzles', theoryPractical: true, exam: 3, chapter: 15},
            ch16Supply: {label: 'Supply Line & Attack', width: 120, theoryPractical: true, exam: 4, chapter: 16},
            ch9Ropes: {label: 'Ropes & Knots', theoryPractical: true, exam: 5, chapter: 9},
            ch11Ladders: {label: 'Ladders', theoryPractical: true, exam: 5, chapter: 11},
            ch5FireBehaviour: {label: 'Fire Behaviour', theoryOnly: true, exam: 6, chapter: 5},
            ch6Building: {label: 'Building Construction', width: 130, theoryOnly: true, exam: 6, chapter: 6},
            ch13Ventilation: {label: 'Ventilation', theoryPractical: true, exam: 7, chapter: 13},
            ch22Command: {label: 'Establish & Transfer Command', width: 160, theoryPractical: true, exam: 7, chapter: 22},
            ch17LiveFire: {label: 'Fire Suppression (Live Fire)', width: 140, theoryPractical: true, exam: 8, chapter: 17},
            ch21Wildland: {label: 'Wildland & Ground Fires', width: 140, theoryPractical: true, exam: 8, chapter: 21},
            firstAid: provincialQualificationAlias('firstAid', {group: 'bcws', groupLabel: 'RDCK/BCWS'}),
            sppWff1: provincialQualificationAlias('sppWff1', {group: 'bcws'}),
            ics100: provincialQualificationAlias('ics100', {group: 'prov'})
        }
    },
    interior: {
        label: 'Interior Operations',
        shortLabel: 'Interior',
        skills: {
            ch12SearchRescue: {label: 'Search & Rescue', theoryPractical: true, exam: 9, chapter: 12},
            ch18Survival: {label: 'Firefighter Survival', theoryPractical: true, exam: 9, chapter: 18},
            ch8Tools: {label: 'FF Tools & Equipment', theoryPractical: true, exam: 10, chapter: 8},
            ch10ForcibleEntry: {label: 'Forcible Entry', theoryPractical: true, exam: 10, chapter: 10},
            ch19Salvage: {label: 'Salvage & Overhaul', width: 110, theoryPractical: true, exam: 11, chapter: 19},
            ch28Origin: {label: 'Fire Origin & Cause', width: 110, theoryOnly: true, exam: 11, chapter: 28},
            ch24Vehicle: {label: 'Vehicle Rescue & Extrication', width: 140, theoryPractical: true, exam: 12, chapter: 24},
            ch25SpecialRescue: {label: 'Assisting Special Rescue', width: 140, theoryPractical: true, exam: 12, chapter: 25},
            ch23AdvLiveFire: {label: 'Advanced Fire Suppression (Live Fire)', width: 185, theoryPractical: true, exam: 13, chapter: 23}
        }
    },
    fullService: {
        label: 'Full Service',
        shortLabel: 'FS',
        skills: {
            ch27LifeSafety: {label: 'Fire & Life Safety', width: 110, theoryPractical: true, exam: 14, chapter: 27},
            ch7Extinguishers: {label: 'Portable Extinguishers', width: 120, theoryPractical: true, exam: 15, chapter: 7},
            ch26Detection: {label: 'Detection/Suppression Systems', width: 180, theoryOnly: true, exam: 15, chapter: 26},
            hazmatOps: sharedQualificationAlias('hazmatOps')
        }
    }
};

// VIERA's Exterior drill section has always stored its first four chapters under
// `truckReady.*`. Generic VIERA has no Truck Ready rung, so display those same cells at
// the start of Exterior. `requiredForLevel: true` tells level completion/credit that
// these are placement aliases which still belong to the level, not duplicate columns.
const vieraExteriorIntroSkills = Object.fromEntries(
    ['ch1FireService', 'ch4Comms', 'ch2Safety', 'ch3Ppe'].map(key => [key, {
        ...VieraRdckSkills.truckReady.skills[key],
        skill: `truckReady.${key}`,
        requiredForLevel: true
    }])
);

const {
    firstAid: _vieraFirstAid,
    sppWff1: _vieraSppWff1,
    ics100: _vieraIcs100,
    ...vieraGenericExteriorSkills
} = VieraRdckSkills.exterior.skills;

const VieraSkills = {
    exterior: {
        ...VieraRdckSkills.exterior,
        // Generic VIERA shows Provincial Requirements as its own section. RDCK's
        // First Aid / WSPP / ICS aliases only exist to preserve its historical layout.
        skills: {...vieraExteriorIntroSkills, ...vieraGenericExteriorSkills}
    },
    interior: VieraRdckSkills.interior,
    fullService: VieraRdckSkills.fullService
};

// One matrix column per J&B chapter, built from the drill catalogue itself so a column
// and the drills that write to it can't drift apart. Columns sit under a header per
// teaching module, and a chapter with no skill drills is theory only.
const nfpa1010LevelSkills = section => Object.fromEntries(section.chapters.map(ch => [ch.skillKey, {
    label: ch.matrixLabel || ch.label,
    ...(ch.width ? {width: ch.width} : {}),
    ...(ch.theoryOnly ? {theoryOnly: true} : {theoryPractical: true}),
    exam: ch.exam,
    chapter: ch.chapter,
    group: `module${ch.module}`,
    groupLabel: `Module ${ch.module}`
}]));

// NFPA 1010 (Jones & Bartlett) — for departments training from J&B's Fundamentals of
// Firefighter Skills rather than VIERA's program. Firefighter I and II are the ladder,
// with the drills in ./skillDrillsNfpa1010.js.
//
// Hazmat Operations is the program's Module 9, a stand-alone course rather than a set of
// drills, so it's a certificate on Firefighter II — the way VIERA files NFPA 1072 Hazmat
// Ops on Full Service — and must be held before Firefighter II is signed off (#1450).
const Nfpa1010Skills = {
    ff1: {
        label: 'Firefighter I',
        shortLabel: 'FF I',
        skills: nfpa1010LevelSkills(Nfpa1010SkillDrills.ff1)
    },
    ff2: {
        label: 'Firefighter II',
        shortLabel: 'FF II',
        skills: {
            ...nfpa1010LevelSkills(Nfpa1010SkillDrills.ff2),
            hazmatOps: sharedQualificationAlias('hazmatOps', {group: 'module9', groupLabel: 'Module 9'})
        }
    }
};

// COTR's BC-minimum-standard view over the canonical J&B chapter cells. A skill alias
// makes the matrix read and edit the existing `ff1` / `ff2` record; unit metadata only
// controls the COTR column grouping. The Requirements sections are generated from the
// same COTR_LEVEL_MAP in skillDrillsCotr.js, so the matrix and checklist cannot drift.
const cotrLevelSkills = levelKey => {
    const skills = {};
    const section = CotrSkillDrills[`cotr${levelKey[0].toUpperCase()}${levelKey.slice(1)}`];

    for (const chapter of section.chapters) {
        if (skills[chapter.skillKey]) continue;
        skills[chapter.skillKey] = {
            label: chapter.matrixLabel || chapter.label,
            width: chapter.width,
            chapter: chapter.chapter,
            skill: `${chapter.group}.${chapter.skillKey}`,
            group: chapter.unit,
            groupLabel: chapter.unitLabel,
            ...(chapter.drills.length ? {progressDrills: chapter.drills.map(drill => drill.code)} : {})
        };
    }

    // COTR's matrix places responsibility certificates alongside the curriculum
    // level while keeping the record at its shared path. A whole qualification
    // such as Fire Officer 1 expands to its component cells; the ordinary shared
    // Fire Officer category and level cell remain available as well.
    const seenPaths = new Set();
    for (const cert of COTR_LEVEL_MAP[levelKey].certs) {
        const [category, key] = cert.path.split('.');
        // Provincial certificates already have their own ordered section. Repeating
        // them here created a second Exterior > Department block for the same cells.
        // Non-provincial COTR/department qualifications still belong beside the
        // curriculum level that calls for them.
        if (category === 'provincial') continue;
        const targets = key
            ? [[key, Skills[category]?.skills?.[key]]]
            : Object.entries(Skills[category]?.skills || {});
        for (const [targetKey, targetDef] of targets) {
            const targetPath = `${category}.${targetKey}`;
            if (seenPaths.has(targetPath) || targetDef === undefined) continue;
            seenPaths.add(targetPath);
            const targetConfig = typeof targetDef === 'string' ? {label: targetDef} : targetDef;
            // This is an alias, not another rename declaration. Carrying the
            // target's oldMappings here would incorrectly remap legacy paths to
            // the COTR display-only alias during catalogue union lookups.
            const {oldMappings: _oldMappings, ...config} = targetConfig;
            skills[`${category}_${targetKey}`] = {
                ...config,
                skill: targetPath,
                group: cert.responsibility,
                groupLabel: cert.responsibility === 'department' ? 'Department' : 'COTR'
            };
        }
    }

    return skills;
};

const CotrSkills = {
    exterior: {label: 'Exterior', skills: cotrLevelSkills('exterior')},
    interior: {label: 'Interior', skills: cotrLevelSkills('interior')},
    fullService: {label: 'Full Service', shortLabel: 'FS', skills: cotrLevelSkills('fullService')}
};

// The provider catalogues the department app, the hub and the api all resolve against.
// VIERA and NFPA 1010 replace JIBC's three ladder levels with their own and keep every
// other JIBC category (Team Leader, Fire Officer, and the `extra: true` certification
// blocks) — same composition the ladders in ./qualificationLevels.js assume.
const withSharedSkills = (providerSkills, {hideProvincial = false} = {}) => {
    const {provincial, exterior, interior, fullService, shared, department, ...otherShared} = Skills;
    if (hideProvincial) {
        // RDCK's established matrix places these canonical cells inside Truck Ready and
        // Exterior. Keep the canonical category available for path/label resolution, but
        // do not render a new Provincial Requirements level ahead of Truck Ready.
        return {...providerSkills, ...otherShared, provincial: {...provincial, storageOnly: true}, shared, department};
    }
    return {provincial, ...providerSkills, ...otherShared, shared, department};
};

const SkillCatalogues = {
    jibc: Skills,
    // Keep `viera` on the historical RDCK shape so deployed departments do not change
    // matrices merely by upgrading. New generic VIERA selections use `vieraGeneric`.
    viera: withSharedSkills(VieraRdckSkills, {hideProvincial: true}),
    vieraGeneric: withSharedSkills(VieraSkills),
    nfpa1010: withSharedSkills(Nfpa1010Skills),
    cotr: withSharedSkills(CotrSkills)
};

// Every training provider a department can choose, in the order the settings offer them.
// `columnGroups` — the provider curriculum declares `group` / `exam` on its cells and the
// matrix draws a header row of sub-groups over them. Provincial Requirements deliberately
// stays ungrouped, and JIBC has no subgroup row at all.
const TrainingProviders = [
    {value: 'jibc', label: 'JIBC'},
    {value: 'vieraGeneric', label: 'VIERA', columnGroups: true},
    {value: 'viera', label: 'VIERA (RDCK)', columnGroups: true},
    {value: 'nfpa1010', label: 'COTR – NFPA 1010 FF I/II (J&B 5th)', columnGroups: true},
    {value: 'cotr', label: 'COTR – BC Minimum Standards (J&B 5th)', columnGroups: true}
];

const TRAINING_PROVIDER_KEYS = TrainingProviders.map(provider => provider.value);

const isTrainingProvider = value => TRAINING_PROVIDER_KEYS.includes(value);

const providerHasColumnGroups = trainingProvider =>
    Boolean(TrainingProviders.find(provider => provider.value === trainingProvider)?.columnGroups);

const skillsForProvider = trainingProvider =>
    SkillCatalogues[trainingProvider] || SkillCatalogues[DEFAULT_TRAINING_PROVIDER];

// See ./skillCatalog.js for what a catalogue is and how aliases and renames differ.
const buildSkillCatalog = (options = {}) => createSkillCatalog({...options, catalogues: SkillCatalogues});

// Follow a skill definition's alias to the entry it names (see ./skillCatalog.js).
// Defaults to the JIBC catalogue for the callers — the hub's column headers and filter
// options — that only ever resolve built-in definitions.
const resolveSkillDef = (def, catalogue = Skills) => resolveSkillDefIn(def, catalogue);

// Standalone rename resolution for callers holding a skill path but no department
// settings. `oldMappings` can only be declared on the built-in catalogues — a custom
// category is authored as {uid, label} pairs and can't carry one — so the built-in
// resolution is the whole answer and needs no settings read.
const {canonicalSkillPath} = buildSkillCatalog();

const ensureJSDates = obj => {
    // Handle Moment objects first
    if (moment.isMoment(obj)) {
        return obj.toDate();
    }

    // Handle null, non-objects, and Date objects
    if (obj === null || typeof obj !== 'object' || obj instanceof Date) {
        return obj;
    }

    // Preserve binary blobs (browser File/Blob picks). They're objects with no
    // enumerable own keys, so recursing would rebuild them as {} and silently
    // drop the upload payload — e.g. attaching a file to a task then saving fails
    // with "No file provided" (#1421 / LIONSBAYFD-7).
    if (typeof Blob !== 'undefined' && obj instanceof Blob) {
        return obj;
    }

    // Handle arrays
    if (Array.isArray(obj)) {
        return obj.map(item => ensureJSDates(item));
    }

    // Handle objects
    const result = {};
    Object.keys(obj).forEach(key => {
        const value = obj[key];
        if (moment.isMoment(value)) {
            result[key] = value.toDate();
        } else if (typeof value?.toDate === 'function') {
            result[key] = value.toDate();
        } else if (Array.isArray(value)) {
            result[key] = value.map(item => ensureJSDates(item));
        } else if (typeof value === 'object' && value !== null) {
            result[key] = ensureJSDates(value);
        } else {
            result[key] = value;
        }
    });

    return result;
};

const ensureMomentDates = obj => {
    // Handle Date objects and Firestore Timestamps first
    if (obj instanceof Date || (typeof obj?.toDate === 'function' && obj.toDate() instanceof Date)) {
        return moment(obj.toDate ? obj.toDate() : obj);
    }

    // Handle null, non-objects, and Moment objects
    if (obj === null || typeof obj !== 'object' || moment.isMoment(obj)) {
        return obj;
    }

    // Handle arrays
    if (Array.isArray(obj)) {
        return obj.map(item => ensureMomentDates(item));
    }

    // Handle objects
    const result = {};
    Object.keys(obj).forEach(key => {
        const value = obj[key];
        if (value instanceof Date) {
            result[key] = moment(value);
        } else if (typeof value?.toDate === 'function' && value.toDate() instanceof Date) {
            result[key] = moment(value.toDate());
        } else if (Array.isArray(value)) {
            result[key] = value.map(item => ensureMomentDates(item));
        } else if (typeof value === 'object' && value !== null) {
            result[key] = ensureMomentDates(value);
        } else {
            result[key] = value;
        }
    });

    return result;
};

// Abbreviated group names for Firebase custom claims (1000 char limit)
const GroupKeyMap = {
    stations: 'st',
    users: 'us',
    apparatus: 'ap',
    fuel: 'fu',
    apparatusChecks: 'ac',
    gearChecks: 'gc',
    stationChecks: 'sc',
    editChecks: 'ec',
    incidents: 'in',
    reports: 'rt',
    events: 'ev',
    training: 'tr',
    lessonplans: 'lp',
    requirements: 'co',
    gear: 'ge',
    items: 'it',
    records: 're',
    tasks: 'ta',
    payroll: 'pa',
    nfpa: 'nf',
    dutyShifts: 'ds',
    preplans: 'pp',
    burnPermits: 'bp',
    sops: 'so',
    files: 'fi',
    publicEducation: 'pe',
    deployments: 'dp',
    hr: 'hr',
    regionalCalendar: 'rc',
    ohs: 'oh'
};

// Abbreviated action names
const ActionKeyMap = {
    read: 'r',
    write: 'w',
    delete: 'd',
    stats: 's',
    approve: 'a',
    assign: 'as',
    report: 'rp',
    submitHours: 'sh',
    request: 'rq',
    manage: 'm'
};

// Build full key -> short key map from Permissions object
const PermissionKeyMap = {};
const ReversePermissionKeyMap = {};

Object.keys(Permissions).forEach(group => {
    const shortGroup = GroupKeyMap[group];
    if (!shortGroup) return;

    const {permissions = {}} = Permissions[group];
    Object.keys(permissions).forEach(action => {
        const shortAction = ActionKeyMap[action];
        if (!shortAction) return;

        const fullKey = `${group}.${action}`;
        const shortKey = `${shortGroup}.${shortAction}`;
        PermissionKeyMap[fullKey] = shortKey;
        ReversePermissionKeyMap[shortKey] = fullKey;
    });
});

/**
 * Converts full permission keys to abbreviated keys for Firebase custom claims storage
 * @param {Object} permissions - Permissions with full keys (e.g. "apparatusChecks.delete")
 * @returns {Object} Permissions with short keys (e.g. "ac.d")
 */
const minifyPermissionKeys = permissions => {
    if (!permissions || typeof permissions !== 'object') {
        return {};
    }

    const minified = {};
    Object.entries(permissions).forEach(([key, value]) => {
        const shortKey = PermissionKeyMap[key];
        minified[shortKey || key] = value;
    });

    return minified;
};

/**
 * Converts abbreviated permission keys back to full keys
 * Passes through unrecognized keys unchanged (backwards compatible with old format)
 * @param {Object} permissions - Permissions with short or full keys
 * @returns {Object} Permissions with full keys
 */
const expandPermissionKeys = permissions => {
    if (!permissions || typeof permissions !== 'object') {
        return {};
    }

    const expanded = {};
    Object.entries(permissions).forEach(([key, value]) => {
        const fullKey = ReversePermissionKeyMap[key];
        expanded[fullKey || key] = value;
    });

    return expanded;
};

/**
 * Removes false values from permissions object to reduce size
 * (false is the default, so we only need to store true values)
 * @param {Object} permissions - The permissions object
 * @returns {Object} Permissions object with false values removed
 */
const cleanPermissions = permissions => {
    if (!permissions || typeof permissions !== 'object') {
        return {};
    }

    // Remove all non-true values - implicit default is false
    const cleaned = {};
    Object.entries(permissions).forEach(([key, value]) => {
        if (value === true) {
            cleaned[key] = value;
        }
    });

    return cleaned;
};

/**
 * Gets size statistics for a permissions object
 * @param {Object} permissions - The permissions object
 * @returns {Object} Object with original size, cleaned size, and savings
 */
const getPermissionsStats = permissions => {
    const originalJson = JSON.stringify(permissions);
    const cleaned = cleanPermissions(permissions);
    const cleanedJson = JSON.stringify(cleaned);

    return {
        originalSize: originalJson.length,
        cleanedSize: cleanedJson.length,
        savings: originalJson.length - cleanedJson.length,
        percentage: Math.round((cleanedJson.length / originalJson.length) * 100)
    };
};

const ApparatusTypes = {
    ENGINE: 'Engine',
    PUMPER: 'Pumper',
    TENDER: 'Tender',
    BUSH: 'Bush Truck',
    LADDER: 'Ladder',
    RESCUE: 'Rescue Truck',
    UTILITY: 'Utility Truck',
    TRAILER: 'Trailer',
    BOAT: 'Boat',
    CAR: 'Car'
};

const ApparatusStatuses = {
    IN_SERVICE: 'In Service',
    RESERVE: 'Reserve',
    OUT_OF_SERVICE: 'Out of Service',
    DECOMMISSIONED: 'Decommissioned'
};

const DecommissionedStatuses = ['DECOMMISSIONED'];

const PayrollStatusLabels = {
    draft: 'Draft',
    submitted: 'Waiting for Approval',
    approved: 'Approved',
    rejected: 'Rejected'
};

// Uniform cap for multipart uploads through the api (#1279). Must stay under
// Cloud Run's 32 MiB HTTP/1 request limit so our friendly rejection always
// fires before the platform's opaque 413. Enforced server-side in the api's
// readMultipart() and client-side in the upload helpers / file fields.
const MAX_UPLOAD_MB = 30;
const MAX_UPLOAD_BYTES = MAX_UPLOAD_MB * 1024 * 1024;

module.exports = {
    OPERATOR_UID,
    HUB_ACCOUNT_UID_PREFIX,
    isOperatorUid,
    isHubAccountUid,
    hubAccountUid,
    parseHubAccountUid,
    isHiddenAccount,
    Permissions,
    DefaultPermissions,
    IncidentTypes,
    IncidentStatuses,
    ApparatusTypes,
    ApparatusStatuses,
    DecommissionedStatuses,
    RecordTypes,
    ApparatusRecordTypes,
    MemberRecordTypes,
    ConfidentialMemberRecordTypes,
    isConfidentialMemberRecord,
    MemberRecordTypesRequiringFile,
    memberRecordRequiresFile,
    TrainingTypes,
    TrainingDisciplines,
    DutyShiftTypes,
    DUTY_SHIFT_TYPE_OTHER,
    dutyShiftTypeLabel,
    dutyShiftDisplayName,
    calculateDutyShiftHours,
    resolveDutyShiftHours,
    cleanStationValue,
    stationAddressText,
    stationName,
    stationNumber,
    stationDisplayName,
    DUTY_SHIFT_REPEAT_OPTIONS,
    MAX_DUTY_SHIFT_OCCURRENCES,
    DUTY_SHIFT_OPEN_ENDED_HORIZON_MONTHS,
    openEndedHorizon,
    repeatIntervalLabel,
    buildRepeatWindows,
    DefaultDutyShiftPresets,
    OccupancyTypes,
    ConstructionTypes,
    TaskStatuses,
    TaskFrequencies,
    OnboardingRequestStatuses,
    OPEN_ONBOARDING_REQUEST_STATUSES,
    OPERATOR_ONBOARDING_REQUEST_STATUSES,
    WITHDRAWABLE_ONBOARDING_REQUEST_STATUSES,
    OnboardingRequestKinds,
    LinkProviders,
    normalizeLink,
    detectLinkProvider,
    PayrollCadences,
    nextPayrollPeriod,
    payrollPeriodOptions,
    payrollPeriodName,
    payPeriodNumber,
    defaultPayrollAnchor,
    resolvePayrollAnchor,
    TaskReminderStages,
    Ranks,
    ShortRanks,
    FirefighterRanks,
    OfficerRanks,
    ChiefRanks,
    rankOrder,
    compareRanks,
    rankChangeDirection,
    TEMPORARY_APPOINTMENTS,
    appointmentTypeOf,
    isTemporaryAppointment,
    permanentRanks,
    RankPrecisions,
    precisionOf,
    coarserPrecision,
    normalizeToPrecision,
    sameInstantAtPrecision,
    normalizeRankChanges,
    resolveEffectiveRank,
    rankTimeline,
    MemberStatuses,
    DisabledStatuses,
    SuspendedStatuses,
    toDateValue,
    normalizeStatusChanges,
    resolveEffectiveStatus,
    isActiveOn,
    intervalsContain,
    activeIntervals,
    trainingAttendeeUids,
    attendedTraining,
    normalizeTrainingType,
    groupTrainingsByType,
    DrivingCodes,
    LicenceClasses,
    Skills,
    VieraSkills,
    VieraRdckSkills,
    Nfpa1010Skills,
    CotrSkills,
    COTR_LEVEL_MAP,
    SkillCatalogues,
    TrainingProviders,
    TRAINING_PROVIDER_KEYS,
    isTrainingProvider,
    providerHasColumnGroups,
    DEFAULT_TRAINING_PROVIDER,
    skillsForProvider,
    buildSkillCatalog,
    canonicalSkillPath,
    resolveSkillDef,
    unionCatalogues,
    SkillDrills,
    LEVEL_LADDERS,
    LEVEL_CERT_PATHS,
    levelLadder,
    isLevelCellComplete,
    impliedByLevel,
    isLevelComplete,
    levelsAtOrBelow,
    levelsCoveredByCredit,
    creditableLevels,
    isImpliableSkill,
    impliableCells,
    isImpliableCell,
    isLevelCert,
    levelCerts,
    levelCompletionCells,
    areAllLevelRequirementsComplete,
    outstandingLevelCerts,
    SKILL_IMPLICATIONS,
    skillImplications,
    isImpliedSkillCreditable,
    impliedSkillCells,
    cellHasOwnRecord,
    SHARED_QUALIFICATION_PATHS,
    LEGACY_QUALIFICATION_PATHS,
    PROVIDER_LEGACY_QUALIFICATION_PATHS,
    preferredLegacyQualificationPath,
    canonicalQualificationPath,
    canonicalQualificationGrouping,
    withCanonicalQualificationFiles,
    qualificationCellAt,
    qualificationDisplayCellAt,
    qualificationCellSourcePath,
    withSharedQualificationFallbacks,
    VieraSkillSheets,
    getSkillSheetGeometry,
    VieraSkillSheetSourceBase,
    VieraSkillSheetEdition,
    VieraSkillSheetEditionLabel,
    VieraSkillSheetEditionRe,
    skillSheetPath,
    skillSheetSkillPath,
    hasSkillSheet,
    getSkillSheet,
    skillSheetsForChapter,
    vieraSkillSheetSourceUrl,
    OFCDriverOperatorSheets,
    OFCDriverOperatorEdition,
    OFCDriverOperatorEditionLabel,
    getOFCDriverOperatorSheet,
    ofcDriverOperatorSheetPath,
    ofcSheetForDrill,
    ofcDocsForExam,
    ensureJSDates,
    ensureMomentDates,
    cleanPermissions,
    getPermissionsStats,
    minifyPermissionKeys,
    LockedIncidentStatuses,
    isCountableIncident,
    TrainingStatuses,
    LockedTrainingStatuses,
    isPayableTraining,
    DEFAULT_STANDBY_HOURS,
    EVALUATION_FORM_THRESHOLD,
    drillsNeededForEvaluationForm,
    meetsEvaluationFormThreshold,
    resolveIncidentMemberRole,
    resolveIncidentHours,
    RESPONSE_LISTS,
    classifyIarResponse,
    latestIarResponses,
    iarResponseSnapshot,
    groupResponsesByList,
    mergeImportedResponses,
    DEFAULT_IAR_IGNORED_RESPONSES,
    DEPARTMENT_TIMEZONE,
    getIncidentMonth,
    getIncidentMonthRange,
    OTHER_APPARATUS_ID,
    isOtherApparatus,
    normalizeTag,
    findApparatusByTag,
    apparatusEntryLabel,
    rotationCrewIds,
    deploymentIntervalsByMember,
    deploymentCovering,
    clusterConcurrentSessions,
    clusterAttendedBy,
    memberStationId,
    memberIncidentAttendance,
    memberTrainingAttendance,
    PERFORMANCE_CHECKLIST_STEP,
    PERFORMANCE_CHECKLIST_HEADING,
    PERFORMANCE_CHECKLIST_ITEM_TYPES,
    PERFORMANCE_CHECKLIST_MAX_ITEMS,
    normalizePerformanceChecklist,
    checklistSteps,
    hasPerformanceChecklist,
    PERFORMANCE_CHECKLIST_PASS,
    PERFORMANCE_CHECKLIST_FAIL,
    ASSESSMENT_NOT_STARTED,
    ASSESSMENT_IN_PROGRESS,
    ASSESSMENT_PASS,
    ASSESSMENT_FAIL,
    assessmentProgress,
    deriveAssessmentStatus,
    timeOffIntervalsByMember,
    timeOffCovering,
    DeploymentStatuses,
    LockedDeploymentStatuses,
    DeploymentRoles,
    DeploymentFileGroupings,
    DeploymentEquipmentStates,
    DeploymentReceiptCategories,
    ApparatusCheckStatuses,
    GearCheckTypes,
    CheckFrequencies,
    CheckFrequencyDurations,
    ApparatusCheckTypes,
    StationCheckTypes,
    PracticeTrainingTypes,
    AttendanceTrainingTypes,
    SelectableTrainingTypes,
    OHS_MEETING_TYPE,
    isOhsMeeting,
    trainingRecordPath,
    PayrollStatusLabels,
    MAX_UPLOAD_MB,
    MAX_UPLOAD_BYTES,
    expandPermissionKeys
};
